import { ILanguage } from "../../../core/model/language/Language";
import { IIndexTypeGroup } from "../../../indexTypes/model/IndexTypeGroup";
import { IOrganisation } from "../../model/Organisation";
import { IOrganisationIndexGroup } from "../../model/OrganisationIndexGroup";
import OrganisationIndexPresentationModel, {
  TOrganisationIndexPresentationModel
} from "./OrganisationIndexPresentationModel";

export interface TOrganisationIndexGroupPresentationModel
  extends IOrganisationIndexGroup {
  nameTranslation: string;
  organisationIndexList: TOrganisationIndexPresentationModel[];
  organisation: IOrganisation;
  indexTypeGroup: IIndexTypeGroup;
  connected: boolean;
}

const OrganisationIndexGroupPresentationModel = (
  data: IOrganisationIndexGroup,
  selectedLanguage?: ILanguage,
  organisation?: IOrganisation,
  indexTypeGroup?: IIndexTypeGroup,
  connected?: boolean
) => {
  const nameTranslation = data.nameTranslations.find(
    (item) => item.languageId === selectedLanguage?.id
  )?.nameTranslation;
  const handler: ProxyHandler<IOrganisationIndexGroup> = {
    get: function (target, prop, receiver) {
      switch (prop) {
        case "nameTranslation":
          return nameTranslation;
        case "organisation":
          return organisation;
        case "indexType":
          return indexTypeGroup ? indexTypeGroup : target.groupType;
        case "connected":
          return connected;
        case "organisationIndexList":
          return data.organisationIndexList?.map((item) =>
            OrganisationIndexPresentationModel(
              item,
              organisation,
              undefined,
              undefined,
              undefined,
              selectedLanguage
            )
          );
        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<
    IOrganisationIndexGroup,
    TOrganisationIndexGroupPresentationModel
  >(data, handler);
};

export default OrganisationIndexGroupPresentationModel;
